import TravelDate from "./TravelDate";
import BookingParticipant from "./BookingParticipant";
import Search from "./Search";
import Model from "./Model";

export default class Booking extends Model {
    constructor(data) {

        super(data, {
            participants: null,
        });

        this.relation('travel_date', TravelDate)
            .relationCollection('participants', BookingParticipant);
    }

    stepFind(step) {
        return this.get('steps').find((elem, index) => step - 1 == index).slug;
    }

    stepFindIndex(slug) {
        return this.get('steps').findIndex((elem) => elem.slug == slug) + 1;
    }
}
